import React from 'react';

import {
	CommonSideNavItemProps,
	CustomComponentItemType,
	CustomComponentItemWithPathType,
	DefaultItemType,
	SideNavItem,
} from '../../../types';

import DefaultSideNavItem from './DefaultSideNavItem';

type MenuItemProps = Omit<CommonSideNavItemProps, 'item'> & { item: SideNavItem };
export const MenuItem = (props: MenuItemProps) => {
	const { item, onClick, isSelected } = props;

	if ('Component' in item && item.Component) {
		if ('path' in item && item.path) {
			const WithPathComponent = item.Component as CustomComponentItemWithPathType['Component'];

			return (
				<WithPathComponent isSelected={isSelected} onClick={onClick} item={item as CustomComponentItemWithPathType} />
			);
		}
		const NoPathComponent = item.Component as CustomComponentItemType['Component'];

		return <NoPathComponent isSelected={isSelected} onClick={onClick} item={item as CustomComponentItemType} />;
	}

	return <DefaultSideNavItem isSelected={isSelected} onClick={onClick} item={item as DefaultItemType} />;
};
